var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.2615 14.6634C5.36233 14.2142 5.179 13.5726 4.85816 13.2517L2.63066 11.0242C1.934 10.3276 1.659 9.58508 1.86066 8.94341C2.0715 8.30174 2.72233 7.86174 3.694 7.69674L6.554 7.22008C6.9665 7.14675 7.47066 6.78008 7.66316 6.40424L9.23983 3.24174C9.69816 2.33424 10.3215 1.83008 10.9998 1.83008C11.6782 1.83008 12.3015 2.33424 12.7598 3.24174L14.3365 6.40424C14.4557 6.64258 14.7032 6.87175 14.969 7.02758L5.0965 16.9001C4.96816 17.0284 4.74816 16.9092 4.78483 16.7259L5.2615 14.6634Z",
    fill: "#333448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1424 13.2567C16.8124 13.5867 16.629 14.2192 16.739 14.6684L17.3716 17.4275C17.6374 18.5734 17.4724 19.435 16.904 19.8475C16.6749 20.0125 16.3999 20.095 16.0791 20.095C15.6116 20.095 15.0616 19.9209 14.4565 19.5634L11.7707 17.9684C11.349 17.7209 10.6524 17.7209 10.2307 17.9684L7.54488 19.5634C6.52738 20.1592 5.65655 20.26 5.09738 19.8475C4.88655 19.6917 4.73072 19.4809 4.62988 19.2059L15.7765 8.0592C16.1982 7.63753 16.7941 7.44503 17.3716 7.54586L18.2974 7.7017C19.269 7.8667 19.9199 8.3067 20.1307 8.94836C20.3324 9.59003 20.0574 10.3325 19.3607 11.0292L17.1424 13.2567Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f2a9f7304d8857700b159a013a67e5c6.svg";
export { ForwardRef as ReactComponent };